/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ByocRegistry, ByocRegistryInterface } from "../ByocRegistry";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "publisher",
        type: "address",
      },
      {
        indexed: true,
        internalType: "string",
        name: "contractId",
        type: "string",
      },
    ],
    name: "AddedContractToPublicList",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "publisher",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isApproved",
        type: "bool",
      },
    ],
    name: "Approved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "publisher",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "contractId",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "publishTimestamp",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "bytecodeHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "implementation",
            type: "address",
          },
        ],
        indexed: false,
        internalType: "struct IByocRegistry.CustomContractInstance",
        name: "publishedContract",
        type: "tuple",
      },
    ],
    name: "ContractPublished",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "publisher",
        type: "address",
      },
      {
        indexed: true,
        internalType: "string",
        name: "contractId",
        type: "string",
      },
    ],
    name: "ContractUnpublished",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "isPaused",
        type: "bool",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "publisher",
        type: "address",
      },
      {
        indexed: true,
        internalType: "string",
        name: "contractId",
        type: "string",
      },
    ],
    name: "RemovedContractToPublicList",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractId",
        type: "string",
      },
    ],
    name: "addToPublicList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_toApprove",
        type: "bool",
      },
    ],
    name: "approveOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllPublicPublishedContracts",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "contractId",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "publishTimestamp",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "bytecodeHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "implementation",
            type: "address",
          },
        ],
        internalType: "struct IByocRegistry.CustomContractInstance[]",
        name: "published",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
    ],
    name: "getAllPublishedContracts",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "contractId",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "publishTimestamp",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "bytecodeHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "implementation",
            type: "address",
          },
        ],
        internalType: "struct IByocRegistry.CustomContractInstance[]",
        name: "published",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractId",
        type: "string",
      },
    ],
    name: "getPublicId",
    outputs: [
      {
        internalType: "uint256",
        name: "publicId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractId",
        type: "string",
      },
    ],
    name: "getPublishedContract",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "contractId",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "publishTimestamp",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "bytecodeHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "implementation",
            type: "address",
          },
        ],
        internalType: "struct IByocRegistry.CustomContractInstance",
        name: "published",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractId",
        type: "string",
      },
    ],
    name: "getPublishedContractVersions",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "contractId",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "publishTimestamp",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "bytecodeHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "implementation",
            type: "address",
          },
        ],
        internalType: "struct IByocRegistry.CustomContractInstance[]",
        name: "published",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isApprovedByPublisher",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextPublicId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "string",
        name: "_publishMetadataUri",
        type: "string",
      },
      {
        internalType: "bytes32",
        name: "_bytecodeHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_implementation",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractId",
        type: "string",
      },
    ],
    name: "publishContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractId",
        type: "string",
      },
    ],
    name: "removeFromPublicList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_pause",
        type: "bool",
      },
    ],
    name: "setPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractId",
        type: "string",
      },
    ],
    name: "unpublishContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ByocRegistryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ByocRegistryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ByocRegistry__factory extends ContractFactory {
  constructor(...args: ByocRegistryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _trustedForwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ByocRegistry> {
    return super.deploy(
      _trustedForwarder,
      overrides || {}
    ) as Promise<ByocRegistry>;
  }
  override getDeployTransaction(
    _trustedForwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_trustedForwarder, overrides || {});
  }
  override attach(address: string): ByocRegistry {
    return super.attach(address) as ByocRegistry;
  }
  override connect(signer: Signer): ByocRegistry__factory {
    return super.connect(signer) as ByocRegistry__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ByocRegistryInterface {
    return new utils.Interface(_abi) as ByocRegistryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ByocRegistry {
    return new Contract(address, _abi, signerOrProvider) as ByocRegistry;
  }
}
